import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Config from '../../core/config';
import { getLayoutStaticData, sendPayment } from '../../store/actions/payment';

import Header from '../../components/Header';
import PciDssInfo from '../../components/PaymentPciDssInfo';
import HelpInfo from '../../components/HelpInfo';
import Article from '../../components/UI/AuxiliaryHoc/Article';
import Main from '../../components/UI/AuxiliaryHoc/Main';
import Footer from '../../components/UI/AuxiliaryHoc/Footer';
import Breadcrumbs from '../../components/Breadcrumbs';
import PaymentFormsWrap from '../../components/PaymentFormsWrap';
import Paragraph from '../../components/UI/Paragraph';
import ErrorMessage from '../../components/ErrorMessage';
import Loader from '../../components/UI/Loader';
import PaymentInfo from '../../components/PaymentInfo';
import PricesInfo from '../../components/PricesInfo';
import ConditionsPopin from '../../components/ConditionsPopin';
import RedirectModal from '../../components/RedirectModal';
import ReadMore from '../../components/ReadMore';
import {pushEcommerceInfo} from '../../helpers/gtm';
import BasketInfo from '../../components/BasketInfo';

function mapStateToProps(state) {
  const {
    payment: {
      layoutStaticData: {
        breadcrumbsSteps,
        firstStepLink,
        secondStepLink,
        payments,
        reminderInfo,
        copyRights,
        logoSrc,
        logoHref,
        logoAriaLabel,
        logoAlt,
        pageTitle,
        pageSubtitle,
        currencySwitcher,
        cancellationPolicy,
        detailsConditionsLinkText,
        pciDssInfo,
        popInConditions,
        metrixSrc,
        transInfo,
        summaryBasket,
        securePaymentText,
        failStatus3DS,
        bookingFailCounter,
        paymentAttemptPopup,
        clearSecureSession,
        clearSecureSessionPopin,
        logoHrefPopup,
        leavePopupData,
      },
      sendPaymentResponse: { code, expirationPopIn, attentionPopIn, successLink },
      userData,
      sendPaymentInProgress,
      sendPaymentSuccess,
      sendPaymentError,
    },
  } = state;

  return {
    reminderInfo: reminderInfo || {},
    pciDssInfo: pciDssInfo || {},
    breadcrumbsSteps: breadcrumbsSteps || [],
    firstStepLink: firstStepLink || '',
    secondStepLink: secondStepLink || '',
    payments: payments || null,
    copyRights: copyRights || '',
    logoSrc: logoSrc || '',
    logoHref: logoHref || '',
    logoAriaLabel,
    logoAlt,
    pageTitle: pageTitle || '',
    pageSubtitle: pageSubtitle || '',
    cancellationPolicy: cancellationPolicy || {},
    detailsConditionsLinkText,
    currencySwitcher: currencySwitcher || {},
    getStaticDataSuccess: state.payment.getStaticDataSuccess,
    popInConditions: popInConditions || {},
    popingCloseButton: expirationPopIn ? false : attentionPopIn ? true : null,
    userData: userData || null,
    code: code || '',
    popIn: expirationPopIn || attentionPopIn || null,
    successLink: successLink || '',
    sendPaymentInProgress,
    sendPaymentSuccess,
    sendPaymentError,
    metrixSrc: metrixSrc || null,
    transInfo: transInfo || null,
    summaryBasket: summaryBasket || null,
    securePaymentText: securePaymentText || '',
    failStatus3DS,
    bookingFailCounter,
    paymentAttemptPopup,
    clearSecureSession,
    clearSecureSessionPopin,
    logoHrefPopup,
    leavePopupData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLayoutStaticData: (payload) => dispatch(getLayoutStaticData(payload)),
    sendPayment: (payload) => dispatch(sendPayment(payload)),
  };
}

class Payment extends PureComponent {
  constructor() {
    super();

    this.state = {
      isDesktop: false,
      isDetailsShow: false,
      isDisplayRedirectModal: false
    };
  }

  componentDidMount() {
    const { getLayoutStaticData } = this.props;
    const {
      payment: { staticData },
    } = Config;

    getLayoutStaticData(window[staticData]);

    this.onChangeDimensions('addResize');
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { summaryBasket } = this.props;
    if (!prevProps.summaryBasket?.g4DataLayerCommonVariables && !!summaryBasket?.g4DataLayerCommonVariables) {
      pushEcommerceInfo(summaryBasket?.g4DataLayerCommonVariables?.enhancedEcommerce)
    }
  }

  onChangeDimensions(action) {
    const getWidth = () =>
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const { lg } = Config.resolution;
    const { isDesktop } = this.state;

    if (action === 'addResize') {
      window.addEventListener('resize', this.onChangeDimensions.bind(this));
    }

    if (getWidth() >= lg && !isDesktop) {
      this.setState({
        isDesktop: !isDesktop,
      });
    } else if (getWidth() < lg && isDesktop) {
      this.setState({
        isDesktop: !isDesktop,
      });
    }
  }

  onSendPayment(data) {
    const { userData, sendPayment } = this.props;

    if (data.sendPayment) {
      return sendPayment(userData);
    }

    return sendPayment(data);
  }

  toggleRedirectModal() {
    const { isDisplayRedirectModal } = this.state;
    const { logoHrefPopup } = this.props;

    if (logoHrefPopup) {
      this.setState({
        isDisplayRedirectModal: !isDisplayRedirectModal
      })
    }
  }

  renderErrorModal() {
    const {
      code,
      popIn,
      popingCloseButton,
      transInfo,
      failStatus3DS,
      clearSecureSession,
      paymentAttemptPopup,
      clearSecureSessionPopin,
    } = this.props;
    const shortLogo = code === 404 || failStatus3DS ? <span className="shortLogo" /> : null;

    if (popIn || failStatus3DS || clearSecureSession) {
      let popupData
      if (failStatus3DS) {
        popupData = paymentAttemptPopup
      }  else if (clearSecureSession){
        popupData = clearSecureSessionPopin
      } else {
        popupData = popIn
      }
      const closeBtn = popupData.withoutClose !== undefined || failStatus3DS ? !popupData.withoutClose : popingCloseButton;

      return (
        <ErrorMessage
          data={popupData}
          shortLogo={shortLogo}
          onClickHandler={(data) => this.onSendPayment(data)}
          className="error__popup"
          isModalActive
          closeBtn={closeBtn}
          closeBtnCta={failStatus3DS}
          transInfo={transInfo}
        />
      );
    }

    return null;
  }

  render() {
    const {
      pciDssInfo,
      breadcrumbsSteps,
      firstStepLink,
      secondStepLink,
      payments,
      copyRights,
      logoSrc,
      logoHref,
      logoAriaLabel,
      logoAlt,
      pageTitle,
      pageSubtitle,
      cancellationPolicy,
      currencySwitcher,
      detailsConditionsLinkText,
      successLink,
      userData,
      sendPaymentInProgress,
      sendPaymentSuccess,
      sendPaymentError,
      popInConditions,
      summaryBasket,
      reminderInfo,
      securePaymentText,
      logoHrefPopup,
      leavePopupData,
    } = this.props;

    const { isDesktop, isDetailsShow, isDisplayRedirectModal } = this.state;
    const { breadcrumbsFirstStep, breadcrumbsSecondStep } = Config.gtm;

    const breadcrumbsItems = [{
      label: breadcrumbsSteps[0],
      url: firstStepLink,
      gtm: breadcrumbsFirstStep,
    }, {
      label: breadcrumbsSteps[1],
      url: secondStepLink,
    }, {
      label: breadcrumbsSteps[2],
      breadcrumbsSecondStep
    }]

    const toggleDetailsModal = (val) => {
      this.setState({
        isDetailsShow: val
      })
    }

    if (successLink) {
      return window.location.replace(successLink);
    }

    return (
      <div className="Payment">
        <div className="Payment__row layout-row">
          {sendPaymentInProgress && !sendPaymentSuccess && !sendPaymentError ? <Loader /> : null}
          {(isDisplayRedirectModal && logoHrefPopup) && (<RedirectModal data={leavePopupData} onClose={() => this.toggleRedirectModal()} />)}
          {this.renderErrorModal()}
          {isDetailsShow && (
            <ConditionsPopin
              popInConditions={popInConditions}
              handleConditionsPopin={() => toggleDetailsModal(false)}
            />
          )}
          <Header
            logoHref={logoHref}
            logoSrc={logoSrc}
            logoAriaLabel={logoAriaLabel}
            logoAlt={logoAlt}
            currencySwitcher={currencySwitcher}
            onLogoClick={logoHrefPopup ? () => this.toggleRedirectModal() : null}
          />
          <div className="Payment__content App__container">
            <Main className="Payment__main">
              <div className="Payment__container">
                <div className="Payment__info">
                  {breadcrumbsItems && (
                    <Breadcrumbs
                      className="Payment__breadcrumbs"
                      steps={breadcrumbsItems}
                      active={2}
                    />
                  )}
                  <h1 className="Payment__title">{pageTitle}</h1>
                  {pageSubtitle && (
                    <p className="Payment__subtitle">{pageSubtitle}</p>
                  )}
                </div>
                {reminderInfo.basket && summaryBasket && (
                  <PricesInfo
                    className="Payment__prices-info"
                    mainPrice={reminderInfo.basket.onlinePrice}
                    secondaryPrice={reminderInfo.basket.hotelPrice}
                    basketData={summaryBasket}
                    reminderInfo={reminderInfo}
                    popInConditions={popInConditions}
                    isDesktop={isDesktop}
                  />
                )}
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                {cancellationPolicy.cancellation_label && (
                  <PaymentInfo
                    className="Payment__element"
                    data={cancellationPolicy}
                    detailsBtn={detailsConditionsLinkText}
                    detailsInfo={popInConditions}
                    toggleDetailsModal={toggleDetailsModal}
                  />
                )}
                {!!payments && (
                  <Article className="Payment__form" key="Payment__content">
                    <PaymentFormsWrap
                      payments={payments}
                      userData={userData}
                      sendPayment={(data) => this.onSendPayment(data)}
                      securePaymentText={securePaymentText}
                      toggleDetailsModal={toggleDetailsModal}
                    />
                  </Article>
                )}
                {!!(!isDesktop && reminderInfo && reminderInfo.apartmentSubtext) && (
                  <ReadMore
                    text={reminderInfo.apartmentSubtext.text}
                    btnMoreText={reminderInfo.apartmentSubtext.moreButton}
                    btnLessText={reminderInfo.apartmentSubtext.lessButton}
                    className="Payment__currency-details"
                  />
                )}
              </div>
              {pciDssInfo ? (
                <Article className="Payment__Pci-Dss-info-container" key="PciDssInfo">
                  <PciDssInfo entity={pciDssInfo} isDesktop={isDesktop} />
                </Article>
              ) : null}
            </Main>
            <div className="Payment__aside">
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              {isDesktop && summaryBasket ? (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <>
                  <BasketInfo
                    data={summaryBasket}
                    className="aside-basket"
                    reminderInfo={reminderInfo}
                    popInConditions={popInConditions}
                    isTitleDisplay
                    isTotalPriseDisplay
                  />
                  {reminderInfo && reminderInfo.apartmentSubtext && (
                    <ReadMore
                      text={reminderInfo.apartmentSubtext.text}
                      btnMoreText={reminderInfo.apartmentSubtext.moreButton}
                      btnLessText={reminderInfo.apartmentSubtext.lessButton}
                      className="Payment__currency-details"
                    />
                  )}
                  {reminderInfo && reminderInfo.helpInfo ? (
                    <HelpInfo
                      title={reminderInfo.helpInfo.label}
                      phone={reminderInfo.helpInfo.contact}
                      desc={reminderInfo.helpInfo.contactText}
                    />
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        </div>
        <Footer className="Footer__row layout-row">
          <div className="App__container">
            {!isDesktop && reminderInfo && reminderInfo.helpInfo ? (
              // eslint-disable-next-line
              <HelpInfo
                title={reminderInfo.helpInfo.label}
                phone={reminderInfo.helpInfo.contact}
                desc={reminderInfo.helpInfo.contactText}
              />
            ) : null}
            {copyRights ? (
              <Paragraph className="Payment__Pci-Dss-info-container__copyRights">
                {copyRights}
              </Paragraph>
            ) : null}
          </div>
        </Footer>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
